import { inject, Injectable } from '@angular/core';
import { User } from '../classes/user.class';
import { ApiService } from './api/api.service';

export interface ConsumerProjects {
    id: number;
    name: string;
    customer_id: number;
    customer_name: string;
}
@Injectable({ providedIn: 'root' })
export class CustomerProjectService {
    private apiService = inject(ApiService);

    getConsumerProjects() {
        return this.apiService.getCallData$<ConsumerProjects[]>(`customerprojects-for-consumers`);
    }

    follow(customerProjectId: number, userId: number) {
        return this.apiService.postCall$<User>(`customer-projects/follow`, { customerProjectId, userId });
    }

    unfollow(customerProjectId: number, userId: number) {
        return this.apiService.postCall$<User>(`customer-projects/unfollow`, { customerProjectId, userId });
    }
}
